export function homeHeroCarousel() {
  document.addEventListener("DOMContentLoaded", function () {
    const carouselItems = document.querySelectorAll("#carousel .carousel-item");

    if (carouselItems && carouselItems.length > 0) {
      let activeItemIndex = Math.floor(Math.random() * carouselItems.length);

      carouselItems.forEach((item, index) => {
        item.style.opacity = index === activeItemIndex ? "1" : "0";
        item.style.transform =
          index === activeItemIndex ? "scale(1)" : "scale(1.2)";
      });

      setInterval(() => {
        const nextItemIndex = (activeItemIndex + 1) % carouselItems.length;

        carouselItems[nextItemIndex].style.opacity = "1";
        carouselItems[nextItemIndex].style.transform = "scale(1)";

        carouselItems[activeItemIndex].style.opacity = "0";
        carouselItems[activeItemIndex].style.transform = "scale(1.2)";

        activeItemIndex = nextItemIndex;
      }, 7000);
    }
  });
}
